export default {
  "common.login": "LOGIN",
  "common.logout": "LOGOUT",
  "common.logged-out": "You have been logged out.",
  "common.log-in-portal": "Use portal to log in.",
  "common.undo": "undo",
  "common.unknown": "unknown",
  "common.save-changes": "Save changes",
  "common.cancel": "Cancel",
  "common.accept": "Accept",
  "common.no-matching-tags": "No matching tags",
  "common.create-tag": "Create tag",
  "common.subscriptionRequired": "Your subscription has expired, go to your account to renew your subscription.",
  "common.alreadySubscribed": "You are already subscribed.",
  "common.loading": "Loading...",
  "common.notFound": "Not found",
  "common.done": "Done",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.next": "Next",
  "common.back": "Back",
  "common.close": "Close",
  "common.open": "Open",
  "common.save": "Save",
  "common.hide": "Hide",
  "common.retry": "Retry",
  "common.refresh": "Refresh",
  "common.save-template": "Save as template",
  "common.choose": "Choose",
  "common.apply": "Apply",
  "common.delete": "Delete",
  "common.reload": "Reload",

  "app.update_available": "A newer version of the app is available.",
  "app.update_reload": "Reload now",

  "menu.invitations": "INVITATIONS",
  "menu.portal": "PORTAL",
  "menu.faq": "FAQ",
  "menu.voicePlans": "Voice Plans",
  "menu.book": "Books",
  "menu.playlist": "Playlist",
  "menu.portal_lower": "Exercises Portal",
  "menu.menu": "Menu",
  "menu.language": "Language",
  "menu.settings": "Settings",
  "menu.home": "Home",
  "menu.back": "Back",
  "menu.subscriptionRequired.tooltip": "Subscription required to access this feature",
  "menu.portal.description": "Play all singing exercises from the Universal Voice Guide here",
  "menu.voicePlans.description": "Create a lesson plan with singing exercises here for yourself or your students",
  "menu.playlist.description": "Create a playlist of your favorite exercises here so they play back-to-back during training",
  "menu.book.description": "Digital PDF versions of the Universal Voice Guide in various languages",
  "menu.account_and_subscription": "Account and subscription",
  "menu.organization": "Organizational License",
  "menu.pricing": "PRICING",
  "menu.organization_pricing": "Organization Pricing",

  "voicePlanList.students": "Students",
  "voicePlanList.teachers": "Teachers",
  "voicePlanList.voiceplans": "Voice Plans",
  "voicePlanList.no-voiceplans": "You don't have any Voice Plans yet!",
  "voicePlanList.toast.delete-voiceplan": "Deleted {{name}}",
  "voicePlanList.all": "All",
  "voicePlanList.add-new-voiceplan.a": "You can add new voiceplans for yourself or a student by clicking the plus button",
  "voicePlanList.add-new-voiceplan.b": "in the lower right corner.",
  "voicePlanList.manage-categories": "Manage tags",
  "voicePlanList.add-category": "Add category",
  "voicePlanList.edit-category": "Edit category",
  "voicePlanList.category-name": "Category name",
  "voicePlanList.category-name-placeholder": "e.g. My Students",
  "voicePlanList.category-tags": "Tags",
  "voicePlanList.category-match-rule": "Matching rule",
  "voicePlanList.match-all": "Match ALL tags",
  "voicePlanList.match-any": "Match ANY tag",
  "voicePlanList.filter": "Filter",
  "voicePlanList.filter-and-settings": "Filter & settings",
  "voicePlanList.categories": "Categories",
  "voicePlanList.manage-tags": "Manage tags",
  "voicePlanList.delete-tag": "Delete tag",
  "voicePlanList.delete-tag-description": "Click the X on a tag to remove it from all voice plans.",
  "voicePlanList.tag-deleted-undo": "Tag deleted. Undo?",
  "voicePlanList.protected-tag": "System tag based on the voice plan's role. It cannot be deleted.",
  "voicePlanList.hide-system-tags": "Hide system tags",
  "voicePlanList.set-color": "Set tag color",
  "voicePlanList.edit-tag-label": "Enter a display name for this tag:",
  "voicePlanList.show-more": "Show more",
  "voicePlanList.show-less": "Show less",

  "playlistList.create-prompt": "Enter playlist name:",
  "playlistList.rename-prompt": "Rename playlist",
  "playlistList.delete-confirm": "Are you sure you want to delete this playlist?",
  "playlistList.no-playlists": "No playlists yet",
  "playlistList.add-new-playlist.a": "Click",
  "playlistList.add-new-playlist.b": "to create a playlist",

  "playlistView.edit": "Edit",
  "playlistView.playback": "Playback",
  "playlistView.playlist-items": "Playlist Items",
  "playlistView.no-items": "No items in playlist",
  "playlistView.search-exercises": "Search Exercises",
  "playlistView.search-placeholder": "Search exercises...",
  "playlistView.play": "Play",
  "playlistView.stop": "Stop",
  "playlistView.add-exercise": "Add Exercise",
  "playlistView.add-tts": "Add TTS",
  "playlistView.add-recording": "Add Voice",
  "playlistView.playlist-name": "Playlist Name",
  "playlistView.by": "by",
  "playlistView.is-private": "This playlist is private or has been removed by the author.",
  "playlistView.back-to-library": "Back",
  "playlistView.add-to-playlist": "Add to Playlist",
  "playlistView.add-first-item": "Add Exercises",
  "playlistView.empty-description": "Add exercises, text-to-speech instructions, or voice recordings to build your practice routine.",
  "playlistView.empty-title": "Your playlist is empty",

  "toast.share-linked-copied": "Share link copied to clipboard",

  "playlistShare.title": "Share Playlist",
  "playlistShare.visibility": "Visibility",
  "playlistShare.only-me": "Only me",
  "playlistShare.with-link": "Anyone with the link",
  "playlistShare.make-public": "Make Playlist Public",
  "playlistShare.link": "Share Link",
  "playlistShare.help-text": "Making a playlist public allows other users to favorite it. Any edits you make will be instantly visible to everyone who has favorited it.",
  "playlistShare.favorite-count": "This playlist has {count} favorites.",
  "playlistShare.private-notice": "This playlist is currently private. Only you can see it.",
  "playlistShare.private-impact": "{count} users who favorited your playlist are no longer able to see it.",

  "voicePlan.no-lessons": "You don't have any lessons yet!",
  "voicePlan.no-lessons-description.a": "You can add new lesson for yourself or a student by clicking the plus button",
  "voicePlan.no-lessons-description.b": "at the right, below the share icon.",
  "voicePlan.wait-for-teacher": "Wait for your teacher to add lessons and assignments!",
  "voicePlan.not-found": "Voice plan not found",
  "voicePlan.not-found-description": "The voice plan you're looking for doesn't exist or has been removed.",
  "voicePlan.back-to-list": "Back to voice plans",

  // This components are actually one sentence,
  // but we need to translate them separately
  // because they have svelte components in between.
  // Bit hacky, I know.
  "lesson.explanation.a": "You can",
  "lesson.explanation.b": "edit the title",
  "lesson.explanation.c": "by tapping",
  "lesson.explanation.d": "Delete this lesson by tapping the",
  "lesson.explanation.e": "Or add a new",
  "lesson.explanation.f": "assignment",
  "lesson.explanation.g": "by tapping the",
  "lesson.explanation.h": "Or choose a template: ",
  "lesson.select-template": "Select a template",
  "lesson.global-template-label": "Global",
  "lesson.global": "Global",
  "lesson.no-templates": "No templates available",
  "lesson.wait-for-teacher": "Wait for your teacher to add assignments!",
  "lesson.toast.deleted-lesson": "Deleted the lesson",
  "lesson.prompt-name": "Enter a name for this lesson",
  "lesson.loading-exercises": "Loading exercises...",
  "lesson.exercises-load-error": "Could not load exercises. Other voice plans on this tab may be affected until you retry.",
  "lesson.prompt-template-name": "Enter a name for this template",
  "lesson.template-name": "Template name",
  "lesson.ask-global": "Do you want to add this lesson to the global templates?",
  "lesson.edit-name": "Edit lesson name",
  "lesson.remove": "Remove lesson",
  "lesson.add": "Add lesson",
  "lesson.save-template": "Save as template",
  "lesson.add-stemprofiel": "Add voice profile",
  "lesson.remove-stemprofiel": "Remove voice profile",
  "lesson.remove-stemprofiel-confirm": "Are you sure you want to remove the voice profile of this lesson? This will clear all filled data.",
  "assignment.toast.deleted-assignment": "Deleted the assignment",

  "voicePlanListItem.namePrompt": "Enter a name for this voice plan",

  "voicePlanInvitation.give-voice-plan-name": "Give your voice plan a name",
  "voicePlanInvitation.accept": "Accept",
  "voicePlanInvitation.decline": "Decline",
  "voicePlanInvitation.open": "Open",

  "newAssignmentModal.add-assignment": "Add assignment",
  "newAssignmentModal.search-placeholder": "Type exercise number or keyword to search...",
  "newAssignmentModal.description": "Description",
  "newAssignmentModal.language": "Language",
  "newAssignmentModal.language-explanation": "Universal Voice has been released in multiple languages, and each language has its own numbering. Choose the language you want to use.",
  "newAssignmentModal.not-teacher": "You need to be a teacher to edit assignments.",
  "newAssignmentModal.template-title-qustion": "What is the title of this template?",
  "newAssignmentModal.template-description-qustion": "What is the description of this template?",
  "newAssignmentModal.template-title-description-required": "Title and description are required to save a template.",

  "invitations.no-invitations": "You don't have any invitations.",
  "invitations.no-invitations-description.a": "You can invite other people as",
  "invitations.no-invitations-description.b": "your student",
  "invitations.no-invitations-description.c": "by clicking the plus button",
  "invitations.no-invitations-description.d": "in the lower right corner.",
  "invitations.invited-by": "Invited by: {{name}}",
  "invitations.pending-title": "Pending invitations",
  "invitations.accepted-title": "Accepted invitations",

  "exercise_editor.no_permission": "You don't have permission to publish exercises. Please contact the administrator.",
  "exercise_editor.title": "Exercise Editor",
  "exercise_editor.description": "When you edit an exercise, it is not immediately published to the app or portal.",
  "exercise_editor.language": "Language",
  "exercise_editor.check_changes": "Check for changes",
  "exercise_editor.checking": "Checking for changes...",
  "exercise_editor.publish_app": "Publish to app",
  "exercise_editor.no_changes": "There are no pending changes",
  "exercise_editor.no_changes_note": "It might take up to a minute for changes to be detected.",
  "exercise_editor.publish_portal": "Publish to portal",
  "exercise_editor.publish_app_first": "Publish to app first",
  "exercise_editor.search_placeholder": "Start typing to find an exercise",
  "exercise_editor.new": "New exercise",
  "exercise_editor.save": "Save",
  "exercise_editor.clear": "Clear",
  "exercise_editor.autocomplete_hint": "Note: Only published exercises will be autocompleted.",
  "exercise_editor.not_found": "Exercise {{id}} not found",
  "exercise_editor.previous": "Previous",
  "exercise_editor.next": "Next",
  "exercise_editor.chapter": "Chapter {{chapter}}",
  "exercise_editor.chapter_more": "More",

  "faq.title": "FAQ",
  "faq.question1": "How can I edit the name of a voice plan, or delete it?",
  "faq.answer1": "Long-press the name of the voice plan in the voiceplan list to reveal the context menu. This menu allows you to edit the name of the voice plan, or delete the voice plan completely.",
  "faq.question2": "How can I edit and sort a lesson?",
  "faq.answer2": "Tap the assignment number, or icon at the top of the assignment to reveal the context menu. This menu allows you to edit the assignment, delete the assignment, or move the assignment to a different position.",
  "faq.qas": [
    {
      "question": "How do I cancel my subscription?",
      "answer": 'You can cancel your subscription by going to your <a href="/settings">account settings</a> and clicking on the red cancel button. Your subscription will remain active until the end date of your current subscription period. <br /><img src="images/faq/cancel_abo_en.png" alt="alt_text" title="cancel subscription"/>',
    },
    {
      "question": "How can I edit the name of a voice plan, or delete it?",
      "answer": "Long-press the name of the voice plan in the voiceplan list to reveal the context menu. This menu allows you to edit the name of the voice plan, or delete the voice plan completely."
    },
    {
      "question": "How can I edit and sort a lesson?",
      "answer": "Tap the assignment number, or icon at the top of the assignment to reveal the context menu. This menu allows you to edit the assignment, delete the assignment, or move the assignment to a different position.<img src=\"/images/assignment_example.png\" alt=\"assignment example\" />"
    },
    {
      question: 'How do I create a voice plan for myself? / How do I invite a student?',
      answer: 'If you want to add a voice plan for yourself or invite a student, click on the orange dot with a white plus sign. You will be directed to a screen where you can enter the title of the voice plan. If it\'s for your student, enter the student\'s email and click \'Invite Student.\' For your own voice plan, enter the title and click \'Create for myself. <img src="images/faq/hoe_maak_ik_een_voiceplan.png" alt="alt_text" title="image_tooltip">'
    },
    {
      question: 'Rename, add tags, or delete Voice Plan:',
      answer: 'To rename, add tags, or delete a voice plan, click on the three dots on the right side of the Voice Plan.<ul><li>Delete: Click on the \'trash can.\'</li><li>Rename: Click on the \'notebook\' and give the plan a new title.</li><li>Add Tag: Click on the \'tag,\' type the tag name you want to give.</li></ul><img src="images/faq/voiceplan_hernoemen.png" alt="alt_text" title="image_tooltip>'
    },
    {
      question: 'How do I add a lesson? And how do I name it?',
      answer: 'If you want to create one or more lessons within a voice plan, click on the orange dot with the white plus sign. A lesson will be created immediately, titled with today\'s date. To give it a specific name, click on the notebook to edit the title, for example, \'Belting\' or \'Developing a higher range.\'<img src="images/faq/hoe_voeg_ik_een_les_toe.png" alt="alt_text" title="image_tooltip"><img src="images/faq/hoe_voeg_ik_een_les_toe_2.png" alt="alt_text" title="image_tooltip">'
    },
    {
      question: 'How do I add an exercise? How do I search for an exercise in the database?',
      answer: 'If you want to add an exercise to your lesson plan, click on the orange plus sign.<img src="images/faq/hoe_voeg_ik_een_oefening_toe.png" alt="alt_text" title="image_tooltip">A screen will appear. To add an exercise from the Universal Voice Portal, enter the exercise number, e.g., \'005.\' Click on the exercise, then press \'Save Changes\' to save your exercise. <img src="images/faq/hoe_voeg_ik_een_oefening_toe_2.png" alt="alt_text" title="image_tooltip"If you want specific instructions or an additional description for the exercise, write it in the text box, e.g., "Ensure you maintain the classical posture" or "Try to sing each note with equal sharpness."'
    },
    {
      question: 'How do I adjust/remove an exercise?',
      answer: 'If you want to adjust an exercise in your lesson plan, click on the orange title of the exercise, e.g., \'005\' (or the orange circle if there\'s no title). Use the arrows to move the exercise up or down in the lesson plan. To delete the exercise, click on the trash can. To edit the exercise, click on the notebook. <img src="images/faq/oefening_aanpassen.png" alt="alt_text" title="image_tooltip">'
    },

    {
      question: 'How do I add a karaoke track from YouTube or Spotify?',
      answer: 'In a Voiceplan, click on the orange plus sign. Instead of searching for an exercise in the database, click on \'Insert\' in the text box. Then click on \'Link.\' Add the URL for the relevant karaoke track and click \'Save Changes.\'<img src="images/faq/ik_wil_een_karaoketrack.png" alt="alt_text" title="image_tooltip">'
    },
    {
      question: 'My teacher invited me, where do I find the invitation?',
      answer: 'In the app\'s top right corner, you\'ll find a menu. Click on \'Invitations.\' There, you\'ll see all lesson plans with pending invitations. If there\'s no invitation, either the voice plan is already in your list, or ask the teacher to invite you again. <img src="images/faq/mijn_docent_heeft_mij.png" alt="alt_text" title="image_tooltip">'
    },
    {
      id: 'share-voice-plan',
      question: 'How can a teacher share a voice plan with a student using the new sharing system?',
      answer: 'The teacher should open the voice plan in the app, click the orange \'Invite People\' button (the user icon with a plus sign) at the top, enter the student\'s email address, and click \'Send Invitation\'. The student will then see the invitation in their own app under the <b>Invitations</b> menu in the top-right corner where they can accept it.'
    }
  ],
  "createVoicePlan.title": "Create Voice Plan",
  "createVoicePlan.send-this-invite-line": "Send this invite link to your student:",
  "createVoicePlan.voice-plan-name": "Voice Plan Name",
  "createVoicePlan.name-for-student": "A name you want to use for this student",
  "createVoicePlan.invite": "Invite",
  "createVoicePlan.create-for-myself": "Create for myself",
  "createVoicePlan.create-for-student-or-yourself": "Create a voiceplan for yourself or for a student!",
  "createVoicePlan.name-for-student-or-self": "A name you want to use for the student or yourself",
  "createVoicePlan.email-to-add": "Email you want to add",
  "createVoicePlan.add": "Add",
  "createVoicePlan.students": "Students",
  "createVoicePlan.name-required": "Please enter a name for this voice plan",
  "createVoicePlan.subtitle": "Set up a new voice plan for yourself or a student",
  "createVoicePlan.basic-info": "Basic Information",
  "createVoicePlan.name": "Voice Plan Name",
  "createVoicePlan.name-placeholder": "e.g. Belting exercises - John",

  "createVoicePlan.invite-people": "Invite People",
  "createVoicePlan.invite-description": "You can optionally invite people to this voice plan. Skip this step if you want to invite later.",

  "invite.title": "Invite People",
  "invite.email-placeholder": "Enter email address",
  "invite.can-edit": "Can edit?",
  "invite.send": "Send Invitation",
  "invite.pending": "Pending",
  "invite.accepted": "Accepted",
  "invite.remove": "Remove",
  "invite.error": "Failed to send invitation",
  "invite.no-invitees": "No one invited yet",
  "invite.migrate-title": "Enable Sharing",
  "invite.migrate-description": "This voice plan uses the old sharing system. Enable it to see who has access and invite new people. Existing users with access will be added automatically.",
  "invite.migrate-enable": "Enable Sharing",
  "invite.migrate-success": "Sharing enabled! The following people have access:",
  "invite.migrate-users-found": "Users with access",
  "invite.migrate-continue": "Continue to Invite",

  "invitation.accept": "Accept",
  "invitation.decline": "Decline",
  "invitation.invited-badge": "Invited",
  "createVoicePlan.role": "Role",
  "createVoicePlan.role-both": "Teacher & Student",
  "createVoicePlan.role-teacher": "Teacher",
  "createVoicePlan.role-student": "Student",
  "createVoicePlan.tags": "Tags",
  "createVoicePlan.add-tags": "Add tags to help organize your voice plans",
  "createVoicePlan.tag-placeholder": "Type a tag and press Enter",
  "createVoicePlan.quick-categories": "Quick add from favorite tags",
  "createVoicePlan.review": "Review",
  "createVoicePlan.create": "Create Voice Plan",

  //"Student has no account yet."
  "createVoicePlan.student-has-no-account": "Student has no account",
  //"Student has an account"    
  "createVoicePlan.student-has-an-account": "Student has an account.",
  // Invite students
  "createVoicePlan.invite-students": "Invite students",
  // Invite student
  "createVoicePlan.invite-student": "Invite student",

  "createVoicePlan.description.a": "After naming this voiceplan you can add emails of the students you want to invite.",
  "createVoicePlan.description.b": "If the student",
  "createVoicePlan.description.c": "has an account",
  "createVoicePlan.description.d": ", they will be added to the voiceplan.",
  "createVoicePlan.description.e": "If they",
  "createVoicePlan.description.f": "don't have",
  "createVoicePlan.description.g": "an account yet, they will see the invite as soon as the log in.",
  "createVoicePlan.description.h": "If you want to create a voiceplan for",
  "createVoicePlan.description.i": "yourself",
  "createVoicePlan.description.j": "just give it a name and click 'create for my self.'",

  "invitation.title": "You have been invited to join a voice plan",
  "invitation.description.a": "Give it a name (the name of your",
  "invitation.description.b": "teacher",
  "invitation.description.c": "perhaps?)",
  "invitation.description.d": "select what role you want",
  "invitation.description.e": "and click accept!",
  "invitation.a-name-for-this-voice-plan": "A name you want to use for this voice plan",

  "invitation.student": "Student",
  "invitation.teacher": "Teacher",
  "invite.banner.title": "New Way of Sharing Voice Plans",
  "invite.banner.description": "We have introduced a new, secure way to share voice plans directly. You are viewing a read-only preview of this voice plan.",
  "invite.banner.student-notice": "To record audio, practice exercises, or fully interact with this voice plan, please ask your teacher to invite you using the new email sharing feature in the app.",
  "invite.banner.teacher-notice": "If you are the teacher/creator of this plan, please open this voice plan in your app, click the orange user-plus icon at the top, enter the student's email, and click 'Send Invitation'.",
  "invite.banner.faq-link": "View FAQ instructions",

  "inlineTagsEditor.tag-color-prompt": "Tag color",
  "inlineTagsEditor.tag-removed": "Tag removed",
  "voicePlanList.filter-by-tags": "Search by tags",
  "voicePlanList.search-by-name": "Search by name",
  "voicePlanList.tags-active": "tags active",
  "voicePlanList.other": "Other",


  "login.login": "LOG IN",
  "login.email": "Email",
  "login.password": "Password",
  "login.userid": "User ID",
  "login.forgot": "Forgot your password?",
  "login.no-account": "NO ACCOUNT YET?",
  "login.the-place": "the place to train your voice online",
  "login.more-than": "more than 1400 exercises",
  "login.try-free": "TRY NOW 2 WEEKS FOR FREE",
  "login.make-account": "CREATE AN ACCOUNT",
  "login.uvi-title": "The Universal Voice Portal",
  "login.uvi-text": "The Universal Voice Portal is the place where you can train your voice online. What does it mean? All exercises (more than 1400) from the Universal Voice Guide are categorized and specified in various styles. An ideal study environment to work quickly and efficiently on your Speech, Belting, Whisper, Classical, or Effects. Each exercise has a sung example by a man and woman, along with instrumental tracks at different pitches, making each exercise suitable for every voice. For every goal, such as singing louder, there are multiple exercises, increasing in difficulty. Suitable for both beginner and professional singers. Whether your goal is to sing higher, lower, louder, with more vibrato or darkness, for every vocal goal you can turn to the Universal Voice Portal.",
  "login.register-page": "14864",
  "login.login-with-google": "Login with Google",
  "login.login-with-wordpress": "Login with Wordpress",
  "login.login-with-password": "Sign In",
  "login.login-with-email": "Sign In via email",
  "login.email-login-link": "Email a login link",
  "login.email-required": "Please enter your email address",
  "login.sending-email-link": "Sending login link...",
  "login.email-link-sent": "A login link has been sent to {{email}}. Check your email and click the link to sign in.",
  "login.wrong-password": "This combination of email and password is not valid.",
  "login.start-migration": "Start account migration",
  "login.unknown-error": "An unknown error occurred, please try again later. Or contact support.",
  "login.migration.1": `<p>We are always working to improve our website and provide you with the best service. Therefore, we have switched to a new provider for the verification of your account. For this reason, you need to reset your password.</p>`,
  "login.migration.2": "More info",
  "login.migration.3": `<p>Resetting your password is very simple. Just follow these steps:</p>
    <ol>
        <li>Click on the link below to go to the password reset page.</li>
        <li>Enter your email address and click "Send".</li>
        <li>You will receive an email with a link to choose your new password.</li>
        <li>Click on the link and enter your new password.</li>
        <li>Confirm your new password and click "Save".</li>
        <li>You can now log in with your new password.</li>
    </ol>
    <p>We hope you are satisfied with this change and continue to enjoy our website. If you have any questions or issues, feel free to contact us.</p>
    <p>Thank you for your understanding and trust in us.</p>`,
  "login.email-sent": "If an account exists with the provided email address, an email has been sent with instructions to reset your password.",
  "login.reset-password": "Reset Password",
  "login.need-to-migrate": "Your account needs to be migrated to proceed, to start click on the button below to reset your password. The whole process only takes a short moment",
  "login.you-will-be-migrating": "You are going to migrate {{email}}",
  "login.street": "Street",
  "login.postcode": "Postcode",
  "login.city": "City",
  "login.after-payment": "You can log in while we check your payment.",
  "login.error": "Login failed. Please try again.",
  "login.title": "Sign in to continue",
  "login.signing-in": "Signing in...",
  "login.sign-in": "Sign In",
  "login.login-to-continue": "Log in to continue.",
  "login.name": "Name",

  "settings.profile": "Profile",
  "settings.interface": "Interface",
  "settings.subscription": "Subscription",
  "settings.billingRenewsOn": "Your subscription renews on {{date}} (next billing).",
  "settings.billingEndsWithoutRenewal": "You have access until {{date}}. This subscription will not renew automatically.",
  "settings.billingAccessUntil": "Your subscription access is valid until {{date}}.",
  "settings.billingIndefiniteAccess": "Your subscription has no scheduled end date or automatic renewal.",
  "settings.subscriptionInfo": "Your subscription is {{subscriptionState}}",
  "settings.payments": "Payments",
  "settings.download": "downloaden",
  "settings.subscriptionStateUnknown": "Your subscription state is unknown",
  "settings.cancelSubscription": "Cancel subscription",
  "settings.cancelSubscriptionShort": "Cancel",
  "settings.save": "Save",
  "settings.inputWarning": "Not allowed: {{input}}",
  "settings.lesson_templates": "Lesson templates",
  "settings.global_templates": "Global templates",
  "settings.subscribeCta": "Subscribe now!",
  "settings.subscribeTeaser": "Subscribe to get access to voiceplans!",

  // UI Settings
  "ui.experimentalNavigation": "Experimental Navigation",
  "ui.currentlyUsingExperimental": "You're currently using our experimental navigation with improved mobile support and modern design.",
  "ui.enableExperimental": "Enable our experimental navigation for improved mobile support and modern UI design.",
  "ui.enabled": "Enabled",
  "ui.disabled": "Disabled",
  "ui.reloadNote": "The page will reload automatically after changing navigation settings to apply the new interface.",

  // New UI Teaser
  "teaser.title": "🚀 Try Out Our New UI!",
  "teaser.subtitle": "Experience our experimental navigation layout with improved usability and modern design",
  "teaser.description": "We've been working on a completely new navigation experience that makes it easier to:",
  "teaser.feature1": "✨ Navigate between different sections",
  "teaser.feature2": "📱 Use the app on mobile devices",
  "teaser.feature3": "🎯 Find what you're looking for faster",
  "teaser.feature4": "🔄 Switch between voice plans and tools",
  "teaser.enableButton": "Enable New Navigation",
  "teaser.note": "This will enable the experimental navigation for your account. You can always disable it from your settings later.",
  "teaser.success": "Success! New navigation enabled successfully.",
  "teaser.reloadMessage": "The page will reload automatically in a few seconds to show the new interface...",
  "teaser.error": "Error:",
  "teaser.tryAgain": "Try Again",

  // Voice Plan List Banner
  "banner.tryNewNavigation": "Try our new experimental navigation!",
  "banner.improvedMobile": "Experience improved mobile navigation and modern UI design. Can also be enabled via settings ⚙️.",
  "banner.tryNow": "Try Now",

  // Purchase Flow
  "purchase.title": "Digital Books Access",
  "purchase.subtitle": "Unlock our complete library of digital books",
  "purchase.feature1": "Access to all digital books",
  "purchase.feature2": "High-quality PDF reading experience",
  "purchase.feature3": "Works on all devices",
  "purchase.feature4": "New books added regularly",
  "purchase.oneTime": "One time",
  "purchase.getAccess": "Get Access Now",
  "purchase.alreadyHaveAccess": "Already have access? Contact support if you're having trouble accessing your books.",

  "errors.userNotFound": "The selected user was not found.",
  "errors.timeout": "The request timed out. Please try again later.",
  "errors.sign_in_required": "Please sign in to continue.",
  "errors.user_exists": "An account with this email address already exists.",

  "errors.awaitingPayment": "You can log in once we have received your payment",
  "payments.subscriptionName": "Universal Voice Subscription",
  "payments.next": "next",
  "payments.previous": "previous",
  "payments.missing-a-payment": "Missing a payment?",
  "payments.retrieve-payments": "Retrieve payments",
  "payments.no-payments": "Geen betalingen gevonden",
  "payments.payments": "Betalingen",
  "payments.period": "Periode",
  "payments.date": "Datum",
  "payments.error": "An error occured, please try again later or contact support.",
  "payment.noPayments": "You have no payments",
  "payment.pending.title": "Payment Pending",
  "payment.pending.message": "Your subscription payment is being processed. This can take anywhere from a few seconds to several days depending on your payment method.",
  "payment.pending.waiting": "Waiting for payment confirmation...",
  "payments.loading": "Loading payments...",
  "payments.generatingInvoices": "Generating {{count}} invoice numbers...",
  "payments.generatingInvoice": "Generating invoice {{current}} of {{total}}...",
  "payments.syncing": "Syncing payments...",

  "subscription.expired": "Expired",
  "subscription.deleted": "Deleted",
  "subscription.active": "Active",
  "subscription.mollie.message.expired": "Your subscription has expired, go to your account to renew your subscription.",
  "subscription.mollie.message.active": "Valid until {{endDate}}",
  "subscription.mollie.canceled": "Canceled",
  "subscription.mollie.name": "Premium",

  "subscription.school.message.expired": "Your school subscription has expired. If this is not correct, please contact your school representative.",
  "subscription.school.message.active": "Valid until {{endDate}}",
  "subscription.school.name": "Educational",

  "subscription.special.message.expired": "Your special subscription is no longer valid, if this is not correct, please contact customer service.",
  "subscription.special.message.active": "Valid for an indefinite period.",
  "subscription.special.message.active.until": "Valid until {{endDate}}",
  "subscription.special.name": "Special",
  "subscription.organization.name": "Organizational License - {{orgName}}",
  "subscription.organization.message.active": "Active via {{orgName}}",
  "subscription.organization.message.revoked": "Your seat license has been revoked by your organization.",
  "subscription.noSubscription": "You have no subscriptions",

  "migration.title": "Retrieving your account",
  "migration.check-payments": "Checking payments",
  "migration.check-subscriptions": "Checking subscriptions",
  "migration.check-ready": "Retrieving your account",
  "migration.no-payments": "No payments found, it may take a couple of minutes to process your payment. If you have already paid, and think this is a mistake, please contact support.",
  "migration.no-subscriptions": "No subscriptions found, it may take a couple of minutes to process your subscription. If you think this is a mistake, please contact support.",
  "migration.explanation": "We need to migrate your account to the new payment platform once. Don't worry, you don't have to do anything, we just ask for a little patience.",
  "migration.takesLong": "This is taking a little bit longer than expected, but we are almost there!",

  "checkout.help.email": "Your email address is filled in because you are logged in.",
  "checkout.content.1": `To try out the portal, we are giving you the first <b class="has-text-primary">two weeks</b> as a gift. You pay €0.02 for this today. You can cancel within two weeks or continue to use our portal for the chosen term amount. The subscription fee will only be debited after two weeks.`,
  "checkout.content.1.discount": `To try out the portal, we are giving you the first <b class="has-text-primary">three months</b> as a gift. You pay €0.02 for this today. You can cancel within three months or continue to use our portal for the chosen term amount. The subscription fee will only be debited after three months.`,
  "checkout.content.1.dynamic": `To try out the portal, we are giving you the first <b class="has-text-primary">{{period}}</b> as a gift. You pay €0.02 for this today. You can cancel within {{period}} or continue to use our portal for the chosen term amount. The subscription fee will only be debited after {{period}}.`,
  "checkout.content.2": "Subscribe now so you can always use the Universal Voice Training Portal!",
  "checkout.free": "Free",
  "checkout.monthly": "Per month",
  "checkout.yearly": "Per year",
  "checkout.quarterly": "Every 3 months",
  "checkout.name": "Name",
  "checkout.email": "Email",
  "checkout.subscription": "Subscription",
  "checkout.docent-code": "Reference code (optional)",
  "checkout.teacher-code-tooltip": "If you take lessons from a Universal Voice Teacher, your instructor may have given you a special code. You can enter it here. If you did not receive one, no problem — it is not required for the rest of the process.",
  "checkout.referred-by-teacher": "Were you referred by one of our teachers?",
  "checkout.teacher-code-explanation": "If you have received a reference code from your teacher, fill it in here.",
  "checkout.discount-code-placeholder": "DISCOUNT CODE",
  "checkout.discount-code-validating": "Validating discount code...",
  "checkout.discount-code-invalid": "Invalid discount code",
  "checkout.trial-period.one-week": "one week",
  "checkout.trial-period.two-weeks": "two weeks",
  "checkout.trial-period.weeks": "{{count}} weeks",
  "checkout.trial-period.one-month": "one month",
  "checkout.trial-period.two-months": "two months",
  "checkout.trial-period.three-months": "three months",
  "checkout.trial-period.six-months": "six months",
  "checkout.trial-period.months": "{{count}} months",
  "checkout.trial-period.days": "{{count}} days",
  "checkout.discount.explanation.three-months": "This discount code extends your trial period to three months.",
  "checkout.to-payment": "To payment",
  "checkout.without-subscription": "Create account without subscription",
  "checkout.password": "Password",

  "cookie.showPreferences": "Show cookie preferences",

  "errors.auth/wrong-password": "Incorrect password. Please try again.",
  "errors.auth/invalid-credential": "Invalid email or password. Please try again.",
  "errors.auth/quota-exceeded": "You've reached your login attempt limit. Please try again later.",
  "errors.auth/timeout": "Your session has timed out. Please try again.",
  "errors.auth/too-many-requests": "Too many login attempts. Please try again later.",
  "errors.auth/unverified-email": "Please verify your email address to continue.",
  "errors.auth/user-cancelled": "Login process canceled.",
  "errors.auth/user-not-found": "User account not found.",
  "errors.auth/user-disabled": "Your account has been disabled. Please contact support.",
  "errors.auth/unknown": "An unknown error occurred ({{code}}: {{message}}). Please try again later.",
  "errors.auth/missing-password": "Please enter a password to continue.",
  "errors.auth/missing-email": "Please enter an email address to continue.",
  "checkout.discount-code": "The following discount code is being applied: {{code}}. The discount will start after you setup your payment method.",
  "checkout.account-type-title": "Choose your account type",

  "registration.title": "Create an account",
  "registration.subtitle": "start to unleash your vocal potential",
  "registration.field.name": "NAME",
  "registration.field.email": "EMAIL",
  "registration.field.password": "PASSWORD",
  "registration.field.docent-code": "DOCENT CODE",
  "registration.button.signup": "SIGN UP",
  "registration.login-link.text": "Already a member?",
  "registration.login-link.action": "Log In Here",
  "checkout.free-account-title": "Free Account",
  "checkout.paid-account-title": "Paid Account",
  "checkout.free-description": "Account only, access digital books (might require in app purchase)",
  "checkout.paid-benefit-1": "Personal voice plans",
  "checkout.paid-benefit-2": "Access to all exercises",
  "checkout.paid-benefit-3": "Access to the portal",
  "checkout.create-free-account": "Create free account",
  "checkout.choose-subscription": "Choose subscription",
  "checkout.can-upgrade-later": "You can always upgrade to a paid account later",
  "checkout.free-account-selected": "Free account selected",
  "checkout.free-account-description": "You are creating a free account without subscription. You can upgrade later at any time.",
  "checkout.payment-acknowledgment": "I understand and agree that after the free trial period, the selected subscription fee will be automatically charged",
  "checkout.payment-acknowledgment-help": "By checking this box you confirm that you understand the terms and agree that we will automatically charge the subscription costs according to your selected plan after the trial period ends.",
  "checkout.payment-acknowledgment-required": "You must agree to automatic billing after the trial period",
  "checkout.back-to-options": "Back to options",
  "checkout.subscription-required-message": "You need a subscription for this feature",
  "checkout.subscription-required": "Please select a subscription plan",
  "checkout.choose-subscription-plan": "Choose your subscription plan",
  "checkout.click-to-subscribe": "Click to subscribe",
  "checkout.payment-complete-sign-in": "Payment complete! Sign in to continue.",
  "checkout.waiting-for-payment": "Waiting for payment",
  "checkout.payment-processing": "Your payment is being processed. This may take a moment.",
  "checkout.checking-subscription": "Checking subscription status...",
  "checkout.payment-timeout": "Payment confirmation is taking longer than expected. You can close this page and check your account later.",
  "checkout.retry-check": "Check pending payment",
  "checkout.processing": "Processing...",
  "checkout.do-not-refresh": "Do not refresh or close this page while payment is being processed.",
  "checkout.payment-canceled-title": "Payment canceled",
  "checkout.payment-canceled-desc": "You canceled the payment. No charges were made.",
  "checkout.payment-failed-title": "Payment failed",
  "checkout.payment-failed-desc": "The payment could not be processed. Please try again or use another payment method.",
  "checkout.payment-expired-title": "Payment session expired",
  "checkout.payment-expired-desc": "The time to complete the payment has expired. Please try again.",
  "checkout.try-again": "Try again",
  "checkout.back-to-checkout": "Back to select subscription",
  "checkout.banner-canceled": "Your previous payment was canceled. Choose a subscription plan to try again.",
  "checkout.banner-failed": "Your previous payment failed. Please try again.",
  "checkout.banner-expired": "Your previous payment session expired. Please try again.",

  "audioplayer.playback-rate": "Choose playback rate, a number between 0.1 and 4.0",
  "audioplayer.audio-player": "Audio player",
  "audioplayer.seek": "Seek",
  "audioplayer.pause": "Pause",
  "audioplayer.play": "Play",
  "audioplayer.replay": "Replay",
  "audioplayer.repeat": "Repeat",
  "audioplayer.transpose-down": "Transpose down",
  "audioplayer.transpose-up": "Transpose up",
  "audioplayer.mute": "Mute",
  "audioplayer.unmute": "Unmute",
  "audioplayer.volume": "Volume",
  "lessonTemplateListItem.namePrompt": "Enter a name for this template",
  "lessonTemplateListItem.confirm-remove": "Are you sure you want to delete this template?",


  "login.needs-password-reset": "Your password needs to be reset, please check your email for a link to reset your password.",

  // PDF Viewer Gesture Hints
  "pdf.gesture.tap-left": "Tap to go back",
  "pdf.gesture.tap-right": "Tap to go forward",
  "pdf.gesture.tap-center": "Tap to toggle toolbar",

  "verifyEmail.title": "Verify Your Email",
  "verifyEmail.subtitle": "A verification email has been sent to <strong>{{email}}</strong>. Please click the link in the email to continue.",
  "verifyEmail.checkSpam": "If you don't see the email, please check your spam folder.",
  "verifyEmail.resendButton": "Resend Verification Email",
  "verifyEmail.resendSuccess": "Verification email sent!",
  "verifyEmail.resendError": "Error sending verification email. Please try again later.",
  "verifyEmail.processing": "Preparing your payment...",

  // Book Selector
  "books.title": "Digital Books",
  "books.subtitle": "Choose a book to read",
  "books.owned": "Owned",
  "books.purchasePending": "Purchase Pending",
  "books.pendingMessage": "Your purchase is being processed. Please wait.",
  "books.pendingDetails": "Your payment is currently pending. Depending on the payment method, this can take several days. If you're sure you didn't complete the payment, you can try purchasing again.",
  "books.purchase": "Purchase - €{{price}}",
  "books.tapForPayment": "Tap for payment options",
  "books.processing": "Processing...",
  "books.close": "Close",
  "books.one-time": "one time",
  "books.get-access": "Get Access Now",
  "books.access-description": "Unlock our complete library of digital books",
  "books.digital-books": "Digital Books",
  "books.all-singing-exercises": "All singing exercises",
  "books.pdf-music-sheets": "PDF music sheets",
  "books.audio-files": "Audio files with exercises",
  "books.video-exercises": "Video exercises",
  "books.practice-tools": "Practice tools",
  "books.purchase-error": "An error occurred during purchase. Please try again.",
  "books.buy-for": "Buy for €{{price}}",
  "books.confirm-purchase": "Confirm Purchase",

  // PDF Viewer Tutorial
  "pdf.tutorial.welcome.title": "Welcome to Reader",
  "pdf.tutorial.welcome.content": "Let's take a quick tour.",
  "pdf.tutorial.zones.title": "Navigation Zones",
  "pdf.tutorial.zones.content": "Tap left to go back, right to go forward, or center for the menu.",
  "pdf.tutorial.toc.title": "Table of Contents",
  "pdf.tutorial.toc.content": "Tap here to see chapters and jump to specific sections.",
  "pdf.tutorial.search.title": "Search",
  "pdf.tutorial.search.content": "Find specific text within the document.",
  "pdf.tutorial.offline.title": "Offline Access",
  "pdf.tutorial.offline.content": "Download the document for faster loading and offline reading.",
  "pdf.tutorial.view.title": "View Options",
  "pdf.tutorial.view.content": "Switch between single page and two-page spread views.",
  "pdf.tutorial.visual.title": "Visual Controls",
  "pdf.tutorial.visual.content": "Zoom in/out or switch between scrolling and page flipping modes.",
  "pdf.tutorial.zone.previous": "Previous",
  "pdf.tutorial.zone.menu": "Menu / Zoom",
  "pdf.tutorial.zone.next": "Next",
  "pdf.tutorial.action.skip": "Skip",
  "pdf.tutorial.action.prev": "Prev",
  "pdf.tutorial.action.next": "Next",
  "pdf.tutorial.action.finish": "Finish",
  "pdf.tutorial.dont_show": "Don't show this again",

  // PDF Cache Controls
  "pdf.cache.download_pdf": "Download PDF",
  "pdf.cache.benefit_text": "Downloading makes pages load faster instantly.",
  "pdf.cache.updating": "Updating...",
  "pdf.cache.downloaded_percentage": "% Downloaded",
  "pdf.cache.pages": "pages",
  "pdf.cache.ready_offline": "Ready for offline use",
  "pdf.cache.download_full": "Download Full PDF",
  "pdf.cache.download_tooltip": "Download for faster loading",
  "pdf.cache.manage_downloads": "Manage Downloads",
  "pdf.cache.remove_download": "Remove Download",
  "pdf.cache.storage_used": "Total Storage Used:",
  "pdf.cache.clear_all": "Clear All",
  "pdf.cache.downloading_pages": "Downloading pages...",
  "pdf.cache.processing": "Processing...",
  "pdf.cache.error_info_unavailable": "Unable to download: PDF information not available",
  "pdf.cache.confirm_download": "Download all {{total}} pages? This ensures smooth reading and offline access.",
  "pdf.cache.success_download": "Successfully downloaded {{total}} pages!",
  "pdf.cache.error_download": "Download failed. Please try again.",
  "pdf.cache.confirm_remove": "Remove download for this PDF?",
  "pdf.cache.error_clear": "Failed to clear cache. Please try again.",
  "pdf.cache.confirm_clear_all": "Remove ALL downloads? This will remove all downloaded PDFs from this device.",
  "pdf.cache.already_downloaded": "All pages are already downloaded.",
  "pdf.cache.storage_full": "This device or Safari does not have enough space for the rest of the book. Delete old downloads or free storage on your iPad.",
  "pdf.cache.partial_download": "{{saved}} of {{total}} pages saved.",
  "pdf.cache.confirm_download_space": "About {{needed}} needed, {{remaining}} available.",

  // PDF Toolbar
  "pdf.toolbar.back": "Back",
  "pdf.toolbar.by": "by",
  "pdf.toolbar.zoom_out": "Zoom Out",
  "pdf.toolbar.zoom_reset": "Reset Zoom",
  "pdf.toolbar.zoom_in": "Zoom In",
  "pdf.toolbar.downloaded": "Downloaded",
  "pdf.toolbar.download": "Download",
  "pdf.toolbar.search": "Search",

  // Fast PDF Viewer
  "pdf.loading_config": "Loading document configuration...",
  "pdf.close": "Close",
  "pdf.debug.mode": "Debug Mode",
  "pdf.debug.info": "Debug Info",
  "pdf.debug.status": "Status",
  "pdf.debug.scrolling": "Scrolling",
  "pdf.debug.current_page": "Current Page",
  "pdf.debug.scale": "Scale",
  "pdf.debug.download_queue": "Download Queue ({{active}} active, {{pending}} pending)",
  "pdf.debug.render_queue": "Render Queue (Priority Order)",
  "pdf.chapters.title": "Chapters",
  "pdf.chapters.none": "No chapters available",
  "pdf.controls.zoom_out": "Zoom Out",
  "pdf.controls.zoom_in": "Zoom In",
  "pdf.controls.continuous": "Continuous Scroll Mode",
  "pdf.controls.scroll": "Scroll",
  "pdf.controls.paginated": "Paginated Mode",
  "pdf.controls.page_flip": "Page Flip",
  "pdf.controls.lock_interface": "Lock Interface for Performance",
  "pdf.controls.unlock_interface": "Unlock Interface",
  "pdf.loading.page": "Loading page {{page}}...",
  "pdf.loading.waiting": "Page {{page}} - Waiting for network... ",
  "pdf.loading.downloading": "Page {{page}} - Downloading... {{percent}}%",
  "pdf.loading.opening": "Page {{page}} - Loading document...",
  "pdf.loading.rendering": "Page {{page}} - Rendering... {{percent}}%",
  "pdf.loading.failed": "Page {{page}} - Rendering failed",
  "pdf.loading.document": "Loading document...",
  "pdf.debug.yes": "Yes",
  "pdf.debug.no": "No",

  // PDF Search
  "pdf.search.placeholder": "Search in PDF...",
  "pdf.search.searching": "Searching...",
  "pdf.search.results": "{{current}} of {{total}}",
  "pdf.search.no_results": "No results",
  "pdf.search.previous_tooltip": "Previous result (Shift+Enter)",
  "pdf.search.next_tooltip": "Next result (Enter)",
  "pdf.search.close_tooltip": "Close search (Escape)",

  // Chapter Navigator
  "pdf.navigator.toggle": "Toggle chapter navigator",
  "pdf.navigator.page_of": "Page {{current}} of {{total}}",
  "pdf.navigator.pages_range": "Pages {{start}}-{{end}}",

  // Portal
  "portal.title": "Portal",
  "portal.language": "Language",
  "portal.unpublished_changes": "Unpublished changes",
  "portal.published": "Published",
  "portal.publishing": "Publishing...",
  "portal.publish": "Publish",
  "portal.disable_edit": "Disable Edit Mode",
  "portal.enable_edit": "Enable Edit Mode",
  "portal.loading": "Loading portal content...",
  "portal.retry": "Retry",
  "portal.no_sections": "No sections",
  "portal.section_title": "Section title",
  "portal.version_history": "Version History",
  "portal.hide": "Hide",
  "portal.loading_versions": "Loading...",
  "portal.no_versions": "No previous versions",
  "portal.restore": "Restore",
  "portal.show_version_history": "Show version history",
  "portal.saving": "Saving...",
  "portal.save": "Save",
  "portal.cancel": "Cancel",
  "portal.no_content": "No content",
  "portal.select_section": "Select a chapter and section",
  "portal.add_chapter": "Add chapter",
  "portal.add_section": "Add section",
  "portal.close": "Close",
  "portal.save_ordering": "Save ordering",
  "portal.sections": "Sections",

  "redirect.title": "New Web Address",
  "redirect.message": "The Universal Voice Portal has moved to a new address! You are currently using an old domain.",
  "redirect.login_notice": "When you click OK, we will redirect you to the new address. You might need to log in again.",
  "redirect.ok": "OK",

  "passkey.sign_in": "Sign in with passkey",
  "passkey.register": "Register with passkey",
  "passkey.manage_title": "Manage Passkeys",
  "passkey.manage_desc": "Add a passkey for fast, secure login without a password.",
  "passkey.add": "Add passkey",
  "passkey.name_placeholder": "Passkey name (e.g. 'My phone')",
  "passkey.default_name": "My passkey",
  "passkey.error": "Passkey error: {{error}}",
  "passkey.error.not_allowed": "Cancelled or timed out.",
  "passkey.error.already_registered": "This passkey is already registered on this device.",
  "passkey.error.not_supported": "Not supported on this device or browser.",
  "passkey.error.security": "Can only be used over a secure connection (HTTPS).",
  "passkey.error.no_matching_credential": "Not recognized or does not belong to this account.",
  "passkey.error.account_exists": "An account with this email already exists. Sign in first, then add a passkey in your account settings.",
  "passkey.code.label": "Code from your email",
  "passkey.code.sent": "We sent a 6-digit code to {{email}}. Enter it to create your passkey.",
  "passkey.code.create": "Create passkey",
  "passkey.code.email_required": "Enter your email address first.",
  "passkey.error.invalid_code": "That code is not correct. Check the email and try again.",
  "passkey.error.code_expired": "This code has expired or was tried too often. Request a new code.",
  "passkey.error.code_wait": "Please wait a minute before requesting a new code.",
  "passkey.error.expired_challenge": "Session expired. Please try again.",
  "passkey.error.unauthorized": "Unauthorized. Please log in again.",

  "passkey.no_passkeys": "No passkeys added yet.",

  "login.no-password-set": "If you signed up using a passkey, please use the 'Sign in with passkey' option above.",
  "registration.passkey-info": "Signing up with a passkey does not set a password. Want to add a password later? Use the 'Forgot password' option on the login page.",
  "stemprofiel.title": "Voice Profile",
  "stemprofiel.updated-days": "Updated {{n}} days ago",
  "stemprofiel.updated-today": "Updated today",
  "stemprofiel.updated-yesterday": "Updated yesterday",
  "stemprofiel.updated-never": "Not yet filled in",
  "stemprofiel.filled": "{{n}}/9 filled",
  "stemprofiel.mode-current": "Current",
  "stemprofiel.mode-goal": "Goal",
  "stemprofiel.footer-filled": "{{n}} of 9 dimensions filled",
  "stemprofiel.reset": "Clear",
  "stemprofiel.save": "Save",
  "stemprofiel.saved-toast": "Voice profile saved",
  "stemprofiel.reset-toast": "Profile cleared",
  "stemprofiel.reset-confirm": "Clear all filled values?",
  "tutorial.action.skip": "Skip",
  "tutorial.action.prev": "Back",
  "tutorial.action.next": "Next",
  "tutorial.action.finish": "Finish",
  "tutorial.dont_show": "Don't show this again",
  "tutorial.cancel_confirm": "Are you sure you want to cancel the tutorial?",
  "tutorial.settings.title": "Tutorials & Help",
  "tutorial.settings.reset_all": "Reset all tutorials",
  "tutorial.settings.reset_success": "Tutorials reset successfully!",
  "tutorial.manage_tags.intro.title": "Manage Tags",
  "tutorial.manage_tags.intro.content": "Welcome to the Tag Manager! Here you can organize and customize tags to categorize your voice plans.",
  "tutorial.manage_tags.create.title": "Create New Tags",
  "tutorial.manage_tags.create.content": "Type a tag name here and press Enter or click the '+' button to create a new custom tag.",
  "tutorial.manage_tags.favorite.title": "Pin to Navigation",
  "tutorial.manage_tags.favorite.content": "Toggle the star icon to pin/unpin tags. Pinned tags appear as quick-filter tabs on your main voice plans dashboard.",
  "tutorial.manage_tags.color.title": "Customize Colors",
  "tutorial.manage_tags.color.content": "Click the color circle to pick a unique color for this tag. Pills and tabs will be styled with this color.",
  "tutorial.manage_tags.edit.title": "Rename Tags",
  "tutorial.manage_tags.edit.content": "Click the pencil icon to edit the display label of a tag. Pinned tabs will show this custom name.",
  "tutorial.manage_tags.system.title": "System Tags",
  "tutorial.manage_tags.system.content": "Toggle this checkbox to hide reserved tags (like Students and Teachers) and focus on your own custom tags.",
  "tutorial.dashboard.quick_filters.title": "Configurable Quick Filters",
  "tutorial.dashboard.quick_filters.content": "Welcome to your new Voice Plans dashboard! Pinned tags now appear here as quick-filter tabs so you can jump between categories instantly.",
  "tutorial.dashboard.tab_all.title": "All Voice Plans",
  "tutorial.dashboard.tab_all.content": "The 'All' tab will always be here, giving you a complete overview of all your voice plans in one place.",
  "tutorial.dashboard.search_btn.title": "Search by Name",
  "tutorial.dashboard.search_btn.content": "Tap the search icon to reveal a search field and filter your Voice Plans by name.",
  "tutorial.dashboard.gear_btn.title": "Manage Tags",
  "tutorial.dashboard.gear_btn.content": "Tap the gear icon to open the Tag Manager. Here you can create tags, set colours, and choose which tags appear as quick-filter tabs at the top (star icon).",
  "tutorial.dashboard.tag_toggles.title": "Multi-Tag Filtering",
  "tutorial.dashboard.tag_toggles.content": "Toggle one or more tags in this bar to filter your voice plans. Only plans matching your selected tags will be displayed.",
  "tutorial.dashboard.edit_tags.title": "Edit Voice Plan Tags",
  "tutorial.dashboard.edit_tags.content": "We've opened the tag editor for this plan. You can click on the tags to add/remove them from this plan directly. Long press any plan to open its menu.",
  "faq.tours.title": "Guided Interactive Tours",
  "faq.tours.intro": "Need a quick walkthrough? Start an interactive guided tour to show you around the application in real-time.",
  "faq.tours.dashboard.title": "Dashboard Onboarding",
  "faq.tours.dashboard.description": "Learn how the new quick-filters, configurable tabs, and voice plan tag options work.",
  "faq.tours.dashboard.button": "Start Dashboard Tour",
  "faq.tours.tags.title": "Tag Manager Walkthrough",
  "faq.tours.tags.description": "Learn how to create, color, rename, and pin tags to your dashboard navigation.",
  "faq.tours.tags.button": "Start Tag Manager Tour",

  "tutorial.create_vp.step1_intro.title": "Create a Voice Plan",
  "tutorial.create_vp.step1_intro.content": "Let's create a new Voice Plan. This tour will guide you through the process step-by-step.",
  "tutorial.create_vp.step1_name.title": "Voice Plan Name",
  "tutorial.create_vp.step1_name.content": "Enter a descriptive name for your Voice Plan, like 'John's Belting Progress' or 'My Classical Practice'.",
  "tutorial.create_vp.step1_next.title": "Next Step",
  "tutorial.create_vp.step1_next.content": "Click here to proceed to the next step and add tags.",
  "tutorial.create_vp.step2_tags.title": "Organize with Tags",
  "tutorial.create_vp.step2_tags.content": "Add tags to help organize and filter your Voice Plans later. Type a tag and press Enter.",
  "tutorial.create_vp.step2_quick.title": "Quick Tags",
  "tutorial.create_vp.step2_quick.content": "You can also quickly add your favorite pinned tags by clicking them here.",
  "tutorial.create_vp.step2_next.title": "Continue",
  "tutorial.create_vp.step2_next.content": "Click here to proceed to review your new Voice Plan.",
  "tutorial.create_vp.step3_review.title": "Review Details",
  "tutorial.create_vp.step3_review.content": "Take a moment to verify that the name and tags you selected are correct.",
  "tutorial.create_vp.step3_submit.title": "Create Plan",
  "tutorial.create_vp.step3_submit.content": "Click here to finalize and create your new Voice Plan in the database.",
  "tutorial.create_vp.step4_invite.title": "Invite Students or Teachers",
  "tutorial.create_vp.step4_invite.content": "You can share this plan with others by entering their email address. They will receive an invite to join.",
  "tutorial.create_vp.step4_done.title": "All Done!",
  "tutorial.create_vp.step4_done.content": "Click here to finish the tour and open your newly created Voice Plan!",

  "faq.tours.create_vp.title": "Create Voice Plan Tour",
  "faq.tours.create_vp.description": "Step-by-step guide to creating a new Voice Plan, adding tags, and inviting others.",
  "faq.tours.create_vp.button": "Start Create Plan Tour",

  "tutorial.playlist_list.intro.title": "Playlists Library",
  "tutorial.playlist_list.intro.content": "Welcome to your Playlists! Here you can build custom practice sessions with exercises.",
  "tutorial.playlist_list.create.title": "Create a Playlist",
  "tutorial.playlist_list.create.content": "Click this button to create a new playlist. You will be prompted to enter a name for it.",
  "tutorial.playlist_detail.intro.title": "Your Playlist",
  "tutorial.playlist_detail.intro.content": "This is your playlist detail view. Here you can manage the audio items in your practice routine and play them sequentially.",
  "tutorial.playlist_detail.edit.title": "Edit Playlist",
  "tutorial.playlist_detail.edit.content": "Toggle Edit Mode to customize your playlist. In Edit Mode you can add new items, delete them, or drag to reorder.",
  "tutorial.playlist_detail.add_item.title": "Add Audio Items",
  "tutorial.playlist_detail.add_item.content": "Click here to add singing exercises to your playlist.",
  "tutorial.playlist_detail.share.title": "Share Playlist",
  "tutorial.playlist_detail.share.content": "Click here to share this playlist with others. You can make it public or share it directly with teachers and students.",
  "faq.tours.playlist.title": "Playlists Walkthrough",
  "faq.tours.playlist.description": "Learn how to create a playlist, add exercises, reorder them, and share them.",
  "faq.tours.playlist.button": "Start Playlist Tour",
  "admin.impersonating": "Impersonating user {{name}}",
  "admin.stop-impersonation": "Stop Impersonation",

  "organization.title": "Organizational License",
  "organization.create.subtitle": "Purchase a pool of subscription seats for your school, company, or choir. Manage all licenses, members, and renewals in one centralized portal.",
  "organization.create.name_label": "Organization Name",
  "organization.create.name_placeholder": "e.g. Royal Academy of Music",
  "organization.create.seats_label": "Seats count (min 10)",
  "organization.create.interval_label": "Billing Interval",
  "organization.create.interval_monthly": "Monthly (€9.95 / seat / mo)",
  "organization.create.interval_yearly": "Yearly (€99.50 / seat / yr - 2 months free!)",
  "organization.create.submit": "Create & Proceed to Verification Payment",
  "organization.create.note": "Note: You will be redirected to Mollie to complete your payment. Future subscription charges will be debited automatically.",
  "organization.create.modal_title": "New Organizational License",
  "organization.create.modal_subtitle": "Purchase a pool of subscription seats for your team.",
  "organization.create.modal_submit": "Create & Proceed",
  "organization.dashboard.active_organization": "Active Organization",
  "organization.dashboard.title": "Organization Dashboard",
  "organization.dashboard.new_organization": "New Organization",
  "organization.dashboard.admin_label": "Admin: {{email}}",
  "organization.dashboard.manage_admins": "Manage Administrators",
  "organization.dashboard.billing_details": "Billing details",
  "organization.dashboard.view_invoices_and_details": "Invoices & Billing Details",
  "organization.invoices.title": "Invoices & Billing Details",
  "organization.invoices.subtitle": "Manage your billing address, VAT and KvK numbers, and view all organization invoices.",
  "organization.invoices.billing_form_title": "Billing Details & Address",
  "organization.invoices.billing_form_desc": "Set up the details that will appear on your official invoices.",
  "organization.invoices.company_name": "Company name on invoice",
  "organization.invoices.billing_email": "Billing email address",
  "organization.invoices.billing_email_help": "Invoices and payment confirmations will automatically be sent to this address.",
  "organization.invoices.street": "Street and house number",
  "organization.invoices.postcode": "Postal code",
  "organization.invoices.city": "City",
  "organization.invoices.country": "Country",
  "organization.invoices.kvk_number": "Chamber of Commerce (KvK) number (optional)",
  "organization.invoices.vat_number": "VAT number (optional)",
  "organization.invoices.save_button": "Save billing details",
  "organization.invoices.save_success": "Billing details successfully updated.",
  "organization.invoices.list_title": "Invoices",
  "organization.invoices.no_invoices": "No invoices available yet.",
  "organization.invoices.invoice_nr": "Invoice No.",
  "organization.invoices.date": "Date",
  "organization.invoices.description": "Description",
  "organization.invoices.amount": "Amount",
  "organization.invoices.download_pdf": "Download PDF",
  "organization.dashboard.billing_desc_monthly": "Monthly Organizational License",
  "organization.dashboard.billing_desc_yearly": "Yearly Organizational License",
  "organization.dashboard.price_per_seat": "Price per seat: €{{price}}",
  "organization.dashboard.next_renewal": "Next renewal: {{date}}",
  "organization.dashboard.pending_downgrade_notice": "A seat downgrade to {{count}} seats is scheduled for the next renewal date ({{date}}).",
  "organization.dashboard.seat_usage": "Seat Usage",
  "organization.dashboard.seats_assigned": "of {{total}} seats assigned",
  "organization.dashboard.seats_remaining": "{{count}} seats remaining",
  "organization.dashboard.assignment_movements": "{{count}} assignment movements",
  "organization.dashboard.modify_seats": "Modify Seat Count",
  "organization.dashboard.modify_seats_desc": "Increase or decrease the total pool of seats. Decreasing cannot fall below assigned seats ({{usedSeats}}).",
  "organization.dashboard.enterprise_seats_managed": "Seat counts for enterprise licenses are managed by Universal Voice. Contact your account manager to change the number of seats.",
  "organization.dashboard.enterprise_seats_title": "Seat pool",
  "organization.dashboard.update_button": "Update",
  "organization.dashboard.seat_assignments": "Seat Assignments",
  "organization.dashboard.users": "Users",
  "organization.dashboard.no_users": "No users assigned yet.",
  "organization.dashboard.assign_seat_button": "Assign Seat",
  "organization.dashboard.assign_seat_placeholder": "user@example.com",
  "organization.dashboard.seat_id": "Seat ID",
  "organization.dashboard.assigned_user": "Assigned User",
  "organization.dashboard.date_assigned": "Date Assigned",
  "organization.dashboard.action": "Action",
  "organization.dashboard.pending_signup": "Pending Signup",
  "organization.dashboard.unassigned": "Unassigned (Open Seat)",
  "organization.dashboard.revoke_seat": "Revoke Seat",
  "organization.dashboard.ready": "Ready",
  "organization.dashboard.search_seats_placeholder": "Search seat by email address or ID...",
  "organization.dashboard.clear_search": "Clear search",
  "organization.dashboard.search_prompt": "Type an email address or ID to search and manage a specific seat.",
  "organization.dashboard.no_seats_found": "No seats found matching the search query.",
  "organization.admins.title": "Manage Administrators",
  "organization.admins.subtitle": "Manage who can administer this organization's license and assign seats.",
  "organization.admins.add_admin": "Add Admin",
  "organization.admins.email_address": "Email Address",
  "organization.admins.role": "Role",
  "organization.admins.action": "Action",
  "organization.admins.owner": "Owner",
  "organization.admins.co_admin": "Co-admin",
  "organization.admins.remove": "Remove",
  "common.error": "Error",
  "admin.organizations.title": "Organizations",
  "admin.organizations.create_enterprise": "New Enterprise Organization",
  "admin.organizations.search_placeholder": "Search by name, email or ID...",
  "admin.organizations.name": "Name",
  "admin.organizations.type": "Type",
  "admin.organizations.status": "Status",
  "admin.organizations.admins": "Administrators",
  "admin.organizations.seats": "Seats",
  "admin.organizations.actions": "Actions",
  "admin.organizations.activate": "Activate",
  "admin.organizations.suspend": "Suspend",
  "admin.organizations.active": "Active",
  "admin.organizations.suspended": "Suspended",
  "admin.organizations.pending": "Pending Payment",
  "admin.organizations.enterprise": "Enterprise",
  "admin.organizations.mollie_monthly": "Mollie Monthly",
  "admin.organizations.mollie_yearly": "Mollie Yearly",
  "admin.organizations.create_modal_title": "Create Enterprise Organization",
  "admin.organizations.create_modal_desc": "Create an enterprise organization. Enterprise licenses are managed and billed offline.",
  "admin.organizations.admin_email_label": "Administrator Email (existing user)",
  "admin.organizations.seats_label": "Number of seats",
  "admin.organizations.edit_seats": "Modify Seats",
  "admin.organizations.no_orgs_found": "No organizations found",
  "admin.organizations.total_orgs": "Total Organizations",
  "admin.organizations.total_seats": "Total Seats",
  "admin.organizations.active_seats": "Assigned Seats",
  "admin.email_templates.title": "System Email Events",
  "admin.email_templates.subtitle": "Configure email templates and active versions for system events.",
  "admin.email_templates.search_placeholder": "Search by name, ID, category or description...",
  "admin.email_templates.event": "Event",
  "admin.email_templates.category": "Category",
  "admin.email_templates.active_version": "Active Version",
  "admin.email_templates.languages": "Languages",
  "admin.email_templates.actions": "Actions",
  "admin.email_templates.no_events_found": "No email templates found",
  "admin.email_templates.history": "History",
  "admin.email_templates.edit_template": "Edit Template",
  "admin.email_templates.not_configured": "Not configured",
  "organization.list.subtitle": "Manage your organizational licenses and assigned seats",
  "organization.list.back_to_list": "Back to Organizations",

  "pricing.title": "Give Your Voice Room to Grow",
  "pricing.subtitle": "Whether you practice at home, take singing lessons, or lead a choir. Digital PVP provides the ultimate guidance and exercises wherever you are.",
  "pricing.billing.monthly": "Monthly",
  "pricing.billing.quarterly": "Quarterly",
  "pricing.billing.yearly": "Yearly",
  "pricing.billing.save_percent": "Save {{percent}}%",
  "pricing.billing.guarantee": "14-Day Free Trial • No Credit Card Required",
  "pricing.value.v1_title": "Sing & Warm Up Freely",
  "pricing.value.v1_desc": "Practice at your own pace and pitch",
  "pricing.value.v2_title": "Universal Voice Guide",
  "pricing.value.v2_desc": "Official study books and techniques always at hand",
  "pricing.value.v3_title": "Voice Profile & Progress",
  "pricing.value.v3_desc": "Track your vocal range and growth",
  "pricing.value.v4_title": "Teacher Lesson Plans",
  "pricing.value.v4_desc": "Receive custom lesson plans from your coach",

  "pricing.free.title": "Free Account",
  "pricing.free.badge": "GET STARTED FREE",
  "pricing.free.price": "€0",
  "pricing.free.period": "no commitment",
  "pricing.free.description": "Perfect for getting started. Access default trial warm-up lesson plans to test out the app.",
  "pricing.free.cta": "Create Free Account",
  "pricing.free.f1": "Default trial warm-up lesson plans (Free category)",
  "pricing.free.f2": "Access to free basic warm-up exercises",
  "pricing.free.f3": "Practice via web browser on any device",

  "pricing.pro.title": "Pro Plan",
  "pricing.pro.badge_yearly": "MOST POPULAR • BEST VALUE",
  "pricing.pro.badge_quarterly": "SMART CHOICE",
  "pricing.pro.badge_monthly": "FLEXIBLE PLAN",
  "pricing.pro.description": "Unlimited access to all vocal exercises, custom lesson plans from your teacher, and daily practice tools.",
  "pricing.pro.cta": "Start 14-Day Free Trial",
  "pricing.pro.f1": "Receive & use custom lesson plans from your teacher/director",
  "pricing.pro.f2": "Unlimited playback of all singing exercises",
  "pricing.pro.f3": "Adjust tempo and pitch to match your voice",
  "pricing.pro.f4": "Complete digital Universal Voice Guide books (PDF)",
  "pricing.pro.f5": "Create unlimited custom Voice Plans & playlists",
  "pricing.pro.f6": "Create personal Voice Profile & track progress",
  "pricing.pro.f7": "Priority customer support",

  "pricing.matrix.title": "Compare All Features",
  "pricing.matrix.cat_basics": "Basics & Warm-Ups",
  "pricing.matrix.cat_exercises": "Singing Exercises & Audio",
  "pricing.matrix.cat_plans": "Lesson Plans & Coaching",
  "pricing.matrix.cat_books": "Study Books & PDFs",
  "pricing.matrix.cat_apps": "Apps & Offline Practice",
  "pricing.matrix.item_starter_exercises": "Free warm-up exercises",
  "pricing.matrix.item_all_exercises": "Full exercise catalog",
  "pricing.matrix.item_pitch_tempo": "Pitch & tempo adjustments",
  "pricing.matrix.item_starter_plans": "Default trial lesson plans (Free category)",
  "pricing.matrix.item_teacher_plans": "Receive lesson plans from your teacher/director",
  "pricing.matrix.item_create_plans": "Create custom Voice Plans & playlists",
  "pricing.matrix.item_stemprofiel": "Personal Voice Profile creation & tracking",
  "pricing.matrix.item_book_previews": "Study book sample previews",
  "pricing.matrix.item_full_books": "All Universal Voice Guide books (PDF)",
  "pricing.matrix.item_offline_apps": "Offline practice mode (Mobile & Desktop)",
  "pricing.matrix.val_limited": "Basic Selection",
  "pricing.matrix.val_full": "Full Access",
  "pricing.matrix.val_previews": "No Access",
  "pricing.matrix.val_all_books": "All Books",
  "pricing.matrix.val_default_only": "Default Trial Plans Only",
  "pricing.matrix.val_teacher_unlimited": "Full Access (Teacher & Custom)",
  "pricing.matrix.val_unlimited": "Unlimited Creation",
  "pricing.matrix.val_online_only": "Online Only",
  "pricing.matrix.val_full_offline": "Full Offline",
  "pricing.matrix.val_no_access": "Not Included",
  "pricing.matrix.val_pro_only": "Pro Only",

  "pricing.org_teaser.title": "Give Your Choir, Vocal Studio, or School a Boost",
  "pricing.org_teaser.subtitle": "Collaborate with your students or choir members. Share lesson plans, manage seats centrally, and enjoy group discounts.",
  "pricing.org_teaser.cta": "Explore Organization Plans",
  "pricing.faq.title": "Pricing Frequently Asked Questions",
  "pricing.faq.q1": "Can I cancel my subscription at any time?",
  "pricing.faq.a1": "Yes, absolutely! You can cancel your subscription with a single click in your account settings. You will retain full access until the end of your paid billing period.",
  "pricing.faq.q2": "How does the 14-day free trial work?",
  "pricing.faq.a2": "When you start your trial, you get instant 14-day access to all Pro features. You can test exercises, create playlists, and read digital study books. You will only be billed after 14 days if you choose to keep your subscription.",
  "pricing.faq.q3": "Which devices support Digital PVP?",
  "pricing.faq.a3": "Digital PVP is accessible via your web browser on all your devices: smartphone, tablet, laptop, or desktop computer.",
  "pricing.faq.q4": "What is the difference between a free account and a Pro subscription?",
  "pricing.faq.a4": "A free account lets you practice with default trial warm-up plans. To receive custom lesson plans and assignments from your singing teacher or choir director, track your Voice Profile, or create your own plans, a Pro subscription or Organization license is required.",

  "pricing_org.title": "Organization & Institution Licensing",
  "pricing_org.subtitle": "Equip your choir, private vocal studio, music school, or conservatory with multi-seat access, shared curricula, and administrative controls.",
  "pricing_org.switch_individual": "Looking for personal practice? See Individual Plans",
  "pricing_org.tier_ensemble.title": "Small Choir & Ensemble",
  "pricing_org.tier_ensemble.seats": "5 – 15 Member Seats",
  "pricing_org.tier_ensemble.price": "€4.50",
  "pricing_org.tier_ensemble.period": "per seat / month (billed annually)",
  "pricing_org.tier_ensemble.desc": "Ideal for vocal groups, quartet ensembles, and small community choirs practicing together.",
  "pricing_org.tier_ensemble.cta": "Start Group License",
  "pricing_org.tier_school.title": "Music School & Vocal Studio",
  "pricing_org.tier_school.badge": "RECOMMENDED FOR SCHOOLS",
  "pricing_org.tier_school.seats": "16 – 50 Seats (Teachers & Students)",
  "pricing_org.tier_school.price": "€3.50",
  "pricing_org.tier_school.period": "per seat / month (billed annually)",
  "pricing_org.tier_school.desc": "Complete vocal teaching environment with student assignment, shared Voice Plans, and central billing.",
  "pricing_org.tier_school.cta": "Setup Music School",
  "pricing_org.tier_enterprise.title": "Conservatory & Enterprise",
  "pricing_org.tier_enterprise.badge": "ENTERPRISE TIER",
  "pricing_org.tier_enterprise.seats": "50+ Seats / Unlimited Scale",
  "pricing_org.tier_enterprise.price": "Custom Pricing",
  "pricing_org.tier_enterprise.period": "tailored terms & invoicing",
  "pricing_org.tier_enterprise.desc": "For music conservatories, university vocal departments, national choir federations, and enterprise institutions.",
  "pricing_org.tier_enterprise.cta": "Contact Us for Enterprise",
  "pricing_org.features.title": "Organization License Benefits",
  "pricing_org.features.f1": "Centralized member seat allocation & management dashboard",
  "pricing_org.features.f2": "Create & assign custom Voice Plans and exercises to students",
  "pricing_org.features.f3": "Shared repertoire libraries & ensemble rehearsal playlists",
  "pricing_org.features.f4": "Flexible central billing, PO support, and VAT invoices",
  "pricing_org.features.f5": "Dedicated Account Manager & onboarding assistance",
  "pricing_org.features.f6": "Custom SSO (Single Sign-On) & LMS integration options",
  "pricing_org.form.title": "Contact Enterprise Team",
  "pricing_org.form.subtitle": "Fill out the form below and our team will get back to you with a tailored quote within 24 hours.",
  "pricing_org.form.org_name": "Organization Name",
  "pricing_org.form.contact_name": "Contact Person",
  "pricing_org.form.email": "Work Email Address",
  "pricing_org.form.seats": "Estimated Number of Seats",
  "pricing_org.form.type": "Organization Type",
  "pricing_org.form.type_choir": "Choir / Vocal Group",
  "pricing_org.form.type_school": "Private Vocal Studio / Music School",
  "pricing_org.form.type_conservatory": "Conservatory / University",
  "pricing_org.form.type_other": "Other Institution",
  "pricing_org.form.message": "Tell us about your requirements",
  "pricing_org.form.submit": "Send Enterprise Request",
  "pricing_org.form.success_title": "Request Received!",
  "pricing_org.form.success_desc": "Thank you for reaching out. A dedicated Universal Voice specialist will contact you shortly.",

  "pricing.head.title": "Pricing & Overview - Digital PVP",
  "pricing.head.description": "Choose the plan that fits your voice and goals. Start for free or try 14 days free.",
  "pricing.nav.individual": "Individual",
  "pricing.nav.organization": "Choirs & Institutions",
  "pricing.billing.monthly_period": "/ mo",
  "pricing.billing.monthly_note": "Cancel monthly",
  "pricing.billing.quarterly_note": "€18.00 billed quarterly (-14%)",
  "pricing.billing.yearly_note": "€60.00 billed annually (-28%)",
  "pricing.billing.best_deal": "-28% • Best deal",
  "pricing.billing.savings_badge": "Save {{amount}}",
  "pricing.billing.savings_yearly": "You save €24 per year (28% discount)",
  "pricing.billing.savings_quarterly": "You save €12 per year (14% discount)",
  "pricing.billing.savings_monthly": "Maximum flexibility • Cancel monthly",
  "pricing.audio.tooltip": "Listen to sound sample of the platform",
  "pricing.audio.pause": "Pause sound",
  "pricing.audio.play": "Listen to sound harmony",
  "pricing.free.sub": "Ideal for discovering",
  "pricing.free.no_payment": "No payment details or obligations required",
  "pricing.free.includes": "Included in Free:",
  "pricing.pro.sub": "For serious singers & students",
  "pricing.pro.includes": "Everything in Free plus:",
  "pricing.trust.trial": "14 Days Free Trial",
  "pricing.trust.cancel": "Cancel Anytime",
  "pricing.trust.secure": "Secure via iDEAL, Credit Card & Apple Pay",
  "pricing.matrix.subtitle": "Compare all features and find the perfect plan",
  "pricing.matrix.search_placeholder": "Search feature...",
  "pricing.matrix.clear_search": "Clear search",
  "pricing.matrix.filter_all": "All",
  "pricing.matrix.filter_plans": "Lesson Plans",
  "pricing.matrix.filter_exercises": "Exercises",
  "pricing.matrix.header_feature": "Feature",
  "pricing.matrix.empty_search": "No features found for \"{{query}}\"",
  "pricing.matrix.tooltip.starter_plans": "Receive digital lesson plans assigned directly by your teacher",
  "pricing.matrix.tooltip.teacher_plans": "Use all lesson structures from the Universal Voice Method",
  "pricing.matrix.tooltip.create_plans": "Create your own personalized warm-up and practice routines",
  "pricing.matrix.tooltip.starter_exercises": "Free selection of basic warm-up exercises",
  "pricing.matrix.tooltip.all_exercises": "Access to the full archive of over 500+ vocal exercises",
  "pricing.matrix.tooltip.pitch_tempo": "Change pitch and tempo in the player to fit your vocal range",
  "pricing.matrix.tooltip.stemprofiel": "Record your vocal range, voice type, and personal singing goals",
  "pricing.matrix.tooltip.books_access": "Digital Universal Voice Guide guidebooks included",
  "pricing.org_teaser.badge": "Choirs & Schools",
  "pricing.faq.subtitle": "Answers to the most frequently asked questions",
  "pricing_org.head.title": "Organization Licenses & Enterprise - Digital PVP",
  "pricing_org.head.description": "Group licenses for choirs, vocal studios, music schools, and conservatories. Manage multiple licenses, shared lesson plans, and central billing.",
  "pricing_org.tier_ensemble.f1": "5 to 15 member licenses with Pro access",
  "pricing_org.tier_ensemble.f2": "Central admin account for conductor/leader",
  "pricing_org.tier_ensemble.f3": "Shared choir playlists & Voice Plans",
  "pricing_org.tier_ensemble.f4": "Annual automated billing",
  "pricing_org.tier_school.f1": "16 to 50 student & teacher licenses",
  "pricing_org.tier_school.f2": "Assign Voice Plans and tasks to students",
  "pricing_org.tier_school.f3": "Multiple teacher accounts & administrators",
  "pricing_org.tier_school.f4": "Flexibly add licenses throughout the year",
  "pricing_org.tier_school.f5": "Priority email support",
  "pricing_org.tier_enterprise.f1": "50+ up to unlimited licenses",
  "pricing_org.tier_enterprise.f2": "Custom SSO (Single Sign-On) & LMS integration",
  "pricing_org.tier_enterprise.f3": "Digitize your own curriculum & singing materials",
  "pricing_org.tier_enterprise.f4": "Invoicing & PO billing options",
  "pricing_org.tier_enterprise.f5": "Dedicated Account Manager & SLA agreements",
  "pricing_org.features.f1_title": "Central Management",
  "pricing_org.features.f2_title": "Assign Voice Plans",
  "pricing_org.features.f3_title": "Shared Repertoire",
  "pricing_org.features.f4_title": "Flexible Invoicing",
  "pricing_org.features.f5_title": "Dedicated Support",
  "pricing_org.features.f6_title": "SSO & LMS Options",
  "pricing_org.form.org_name_placeholder": "E.g. Royal Academy of Music",
  "pricing_org.form.contact_name_placeholder": "Name",
  "pricing_org.form.email_placeholder": "email@organization.com",
  "pricing_org.form.seats_15_50": "15 – 50 licenses",
  "pricing_org.form.seats_50_100": "50 – 100 licenses",
  "pricing_org.form.seats_100_250": "100 – 250 licenses",
  "pricing_org.form.seats_250_plus": "250+ licenses (Unlimited)",
  "pricing_org.form.message_placeholder": "Describe the requirements or specific questions for your institution...",
  "pricing_org.form.submitting": "Submitting...",
  "pricing_org.calc.badge": "Interactive Seat Calculator",
  "pricing_org.calc.title": "Estimate pricing for your choir or school",
  "pricing_org.calc.seats_label": "seats",
  "pricing_org.calc.recommended_tier": "Recommended Tier",
  "pricing_org.calc.rate_per_seat": "Rate Per Seat",
  "pricing_org.calc.per_month": "/ mo",
  "pricing_org.calc.savings_label": "Savings vs Individual",
  "pricing_org.calc.savings_note": "({{savings}}/yr savings)",
  "pricing_org.trust.central_management": "Central Member Management",
  "pricing_org.trust.invoice_po": "Invoice & PO Support",
  "pricing_org.trust.instant_allocation": "Instant Seat Allocation",
  "pricing_org.trust.gdpr": "GDPR & Privacy Compliant",
  "pricing_org.features.subtitle": "Designed for conductors, vocal teachers, and educational administrators.",
  "pricing_org.faq.q1": "How does allocating member licenses work?",
  "pricing_org.faq.a1": "As an administrator, you get access to a central management dashboard. You can easily invite member emails or upload CSV lists of choir members and students. Licenses can be reassigned at any time.",
  "pricing_org.faq.q2": "Can we pay via official purchase order (PO) / invoice?",
  "pricing_org.faq.a2": "Yes! For choirs, music schools, and conservatories, we support invoicing with official VAT invoices and purchase order (PO) numbers.",
  "pricing_org.faq.q3": "Can teachers and conductors share custom Voice Plans?",
  "pricing_org.faq.a3": "Absolutely. Teachers and conductors can create custom warmup routines and choir playlists and assign them directly to all members or specific voice sections (Soprano, Alto, Tenor, Bass).",
  "pricing_org.faq.q4": "What happens if we need additional licenses during the year?",
  "pricing_org.faq.a4": "You can add extra licenses at any time via your admin dashboard. Costs will be calculated pro-rata for the remainder of your annual subscription term.",
  "common.select_language": "Select language"
}